import { create } from 'zustand';

/** Where the drawer was opened from; the Home card and the Connections dialog card since the A+B merge. */
export type TransfersPanelSource = 'chip' | 'toast' | 'test' | 'propagate' | 'home' | 'connections_dialog';

type TransfersPanelState = {
  open: boolean;
  source?: TransfersPanelSource;
  /**
   * The element that had focus when the drawer opened — the status-bar chip, the Home card's Transfers, the
   * Connections dialog card's Transfers, the toast's "View transfers" (final UI/UX batch C1, R7 / N18). Closing the
   * drawer returns focus to it (`restoreTransfersPanelFocus`). An open drawer keeps its first opener.
   */
  opener: HTMLElement | null;
  show(source: TransfersPanelSource): void;
  close(): void;
};

const focusedElement = (): HTMLElement | null => {
  if (typeof document === 'undefined') return null;
  const active = document.activeElement;
  return active instanceof HTMLElement && active !== document.body ? active : null;
};

export const useTransfersPanelStore = create<TransfersPanelState>((set, get) => ({
  open: false,
  opener: null,
  show: (source) => set({ open: true, source, opener: get().open ? get().opener : focusedElement() }),
  close: () => set({ open: false, source: undefined }),
}));
